import cx from 'classnames2';
import React from 'react';

import styles from './Modal.scss';

export interface IModalProps {
  children: JSX.Element | JSX.Element[];
  overflowVisible?: boolean;
  title?: string;
  headerIcon?: string;
  onClose(): void;
  dataTest?: string;
}

export const Modal: React.FC<IModalProps> = ({ children, title, onClose, headerIcon, overflowVisible, dataTest }) => {
  const dataTestAttribute = dataTest ? { 'data-test': dataTest } : {};
  return (
    <div className={styles.wrapper} {...dataTestAttribute}>
      <div
        className={cx(styles.modal, {
          [styles.overflowVisible]: overflowVisible
        })}
      >
        <div className={styles.close} onClick={onClose} role="button">
          <span className="icon-remove-3" />
        </div>
        {headerIcon && <span className={cx(styles.headerIcon, headerIcon)} />}
        {title && <h2 className={styles.title}>{title}</h2>}
        <div className={styles.content}>{children}</div>
      </div>
      <div className={styles.background} role="button" />
    </div>
  );
};
